import {useField} from "formik";

const DateField = (props) => {
    const [field] = useField(props);
    return (
        <input type="date" {...field} {...props} />
    );
};

export default DateField;